var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVoprositelnyjZnak(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m298.829 106.246h-86.183l-1 14.997h89.184z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m424.109 106.246h-48.445c-7.069-59.749-58.033-106.246-119.664-106.246-22.915 0-45.235 6.576-64.55 19.016l8.123 12.607c16.888-10.877 36.4-16.626 56.427-16.626 58.179 0 105.51 47.322 105.51 105.489 0 52.7-39.341 97.652-91.51 104.563l-6.515.863v30.247h-29.985v-59.9h22.546c40.604-.024 73.637-33.567 73.637-74.774 0-41.231-33.052-74.775-73.679-74.775-40.577 0-73.599 33.46-73.679 74.622h-31.835c.044-30.868 13.487-60.224 36.896-80.561l-9.839-11.321c-22.843 19.846-37.351 47.235-41.088 76.795h-48.568l-34.391 34.384v371.371h14.333l38.633-75.908h239.47v-14.997h-248.666l-28.77 56.527v-330.781l25.604-25.598h41.39c0 .081-.003.162-.003.243v14.844h61.835v-14.844c0-32.962 26.323-59.778 58.679-59.778 32.355 0 58.679 26.816 58.679 59.778 0 32.942-26.308 59.758-58.641 59.777h-37.543v89.894h59.985v-32.286c56.08-10.594 97.655-59.977 98.016-117.628h41.395l25.604 25.598v248.655l-25.604 25.599h-26.705v14.997h32.918l34.391-34.384v-261.079z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m361.115 421.095h14.91v14.997h-14.91z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m83.46 151.196h15v15.023h-15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m113.46 151.279h15v15.023h-15z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m248.493 376.439c24.813 0 45-20.183 45-44.991s-20.187-44.991-45-44.991-45 20.183-45 44.991 20.187 44.991 45 44.991zm0-74.985c16.542 0 30 13.455 30 29.994s-13.458 29.994-30 29.994-30-13.455-30-29.994 13.458-29.994 30-29.994z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVoprositelnyjZnak);
export default __webpack_public_path__ + "static/media/voprositelnyj_znak.1c6ed00c0718d0cfdae9f3a4d5b0157c.svg";
export { ForwardRef as ReactComponent };